import { User } from "./User";
import { Organization } from "../organization/Organization";

export class UserPageModel {

  id: string;
  username: string;

  role: number;
  organizationId: string;

  firstname?: string;
  lastname?: string;
  fullName?: string;
  email?: string;

  organizationWide?: boolean;
  active: boolean;

  isKeycloakLogin: boolean;
  keycloakRealm: string;

  organizationName?: string;
  serviceProviderId?: string;
  serviceProviderName?: string;

  isPlatformOperator: boolean;
  isContractAdmin: boolean;
  isDefaultAdmin: boolean;

  activeChangedBy: User;

  //region FE only values
  isChecked: boolean;
  //endregion FE only values

  static ofUser(user: User): UserPageModel {
    if (user === null) return null;

    const organizationIdValue = user['organizationId'];

    return {
      id: user.id,
      username: user.username,
      role: user.role,
      organizationId: organizationIdValue ? organizationIdValue : user.organization.id,
      organizationName: user['organizationName'],
      active: user.active,
      isKeycloakLogin: user.isKeycloakLogin,
      keycloakRealm: user.keycloakRealm,
      organizationWide: user.isOrganizationWide,
      firstname: user.firstname,
      lastname: user.lastname,
      fullName: user.fullName,
      email: user.email,
      isChecked: false,
      isPlatformOperator: user.isPlatformOperator,
      isContractAdmin: user.isContractAdmin,
      isDefaultAdmin: user.isDefaultAdmin,
      activeChangedBy: user.activeChangedBy
    };
  }

  static notEquals(one, two): boolean {
    return one.id !== null && two.id !== null && one.id !== two.id;
  }

  static equals(one, two): boolean {
    return !UserPageModel.notEquals(one, two);
  }

  static toOrgId(user: UserPageModel): string {
    return user.organizationId;
  }

  static toOrgName(user: UserPageModel): string {
    if (!user.organizationName) return '--';

    return user.organizationName;
  }
}
